import { API_BASE } from './client.js';

export const nowPlayingStreamUrl = `${API_BASE}/spotify/now-playing/stream`;

export const queueStreamUrl = `${API_BASE}/spotify/queue/stream`;
